// TODO: need to synchronize with src\modules\error_code.rs code value
export const BRIDGE_ERRORS = Object.freeze({
  CHANNEL_TIMEOUT: -110020,
  PARAM_IS_NULL: -110030,
  PARAM_IS_INVALID_JSON: -110031
})

export default { 
  BRIDGE_ERRORS 
}